export default{
    token: null,
    loading: false,
    error: "",
    page: {}
}